import { ProviderAvailabilityView } from '../../../api';

export type ProviderScheduleWithKey = ProviderAvailabilityView & {
  key: string;
  checked?: boolean;
  overnight?: boolean;
  allDay?: boolean;
};

export enum FieldsAction {
  Add = 'Add',
  Remove = 'Remove',
}
